export default __webpack_public_path__ + "static/media/appstore.40f55fd4.svg";